<div class="demo-reset-layover">
  <div class="demo-reset-layover__inner">
    <div class="content">
      <h2 i18n="@@demo.layover.title">Resetting demo mode</h2>
      <div class="text">
        <p i18n="@@demo.layover.description">
          Choose "Reset now" to delete all your answers and return back to the home page. Choose
          "Cancel" to continue with your answers.
        </p>
        <p i18n="@@demo.layover.choice.countdown">
          <ng-container>If you make no choice, the page will be reset in </ng-container>
          <ng-container>{{ duration - (interval | async) }}</ng-container>
          <ng-container> seconds</ng-container>.
        </p>
      </div>
      <div class="actions">
        <button i18n="@@demo.layover.action.cancel" class="button" (click)="cancel()">
          Cancel
        </button>
        <button
          i18n="@@demo.layover.action.reset"
          class="button button-accept"
          (click)="resetNow()"
        >
          Reset now
        </button>
      </div>
    </div>
  </div>
</div>
